export default "__VITE_ASSET__D3ECWJy7__"